import React from 'react';
import { Hero } from '../components/home/Hero';
import { QuickFacts } from '../components/home/QuickFacts';
import { UpcomingEvents } from '../components/home/UpcomingEvents';
import { WelcomeWeek } from '../components/welcome/WelcomeWeek';
import { TypicalWeek } from '../components/schedule/TypicalWeek';
import { Mission } from '../components/home/Mission';
import { WelcomeVideo } from '../components/home/WelcomeVideo';
import { FinalCta } from '../components/home/FinalCta';
export function Home() {
  return <>
      <Hero data-id="element-532" data-mp="24i3imbgip9pw" />
      <QuickFacts data-id="element-533" data-mp="24hk7pepablld" />
      <UpcomingEvents data-id="element-534" data-mp="24j4swdppls6k" />
      <WelcomeWeek data-id="element-535" data-mp="29gdbugiom08v" />
      <TypicalWeek data-id="element-536" data-mp="29fvibrnem04n" />
      <Mission data-id="element-537" data-mp="29fc1ke9hphs7" />
      <WelcomeVideo data-id="element-538" data-mp="29etu0lhdnh4z" />
      <FinalCta data-id="element-539" data-mp="29ihnxlqqi5k8" />
    </>;
}